import { useEffect, useState } from 'react';

export const useSearchInput = (value: string, onChange: (query: string) => void, minLength: number) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (query: string) => {
    setInputValue(query);

    const trimmedQuery = query.trim();
    if (trimmedQuery.length >= minLength) {
      onChange(query);
    } else if (!trimmedQuery) {
      onChange('');
    }
  };

  return { inputValue, handleChange };
};
